import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ToastEvent } from '@models/toast-event';
import { ToastService } from '@services/toast.service';
// import { ToastComponent } from '../toast/toast.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-toaster',
  imports: [
  ],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss'
})
export class ToasterComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  toastService = inject(ToastService);
  cdr = inject(ChangeDetectorRef);
  currentToasts: ToastEvent[] = [];

  ngOnInit(): void {
    this.toastService.toastEvents
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toasts) => {
        const currentToast: ToastEvent = {
          type: toasts.type,
          title: toasts.title,
          message: toasts.message,
        };
        this.currentToasts.push(currentToast);
        this.cdr.detectChanges();
      });
  }

  dispose(index: number) {
    this.currentToasts.splice(index, 1);
    this.cdr.detectChanges();
  }
}
